import { render, staticRenderFns } from "./ProductDividends.vue?vue&type=template&id=1abaf6d1&scoped=true&"
import script from "./ProductDividends.vue?vue&type=script&lang=ts&"
export * from "./ProductDividends.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDividends.vue?vue&type=style&index=0&id=1abaf6d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abaf6d1",
  null
  
)

export default component.exports